import { ADMIN, CONSULTANT, RECRUITER, SALES_PERSON, MANAGER } from '@/lib/constants/securityRoles'

export const loginRoute = {
  name: 'LOGIN',
  path: '/login',
  url: '/login'
}

export const logoutRoute = {
  name: 'LOGOUT',
  path: '/logout',
  url: '/logout',
  roles: [ ADMIN, CONSULTANT, RECRUITER, SALES_PERSON, MANAGER ]
}

export const notAuthorizedRoute = {
  name: 'NOT_AUTHORIZED',
  path: '/notAuthorized',
  url: '/notAuthorized'
}

export const defaultRoute = {
  name: 'DEFAULT',
  path: '/',
  url: '/',
  roles: [ ADMIN, CONSULTANT, RECRUITER, SALES_PERSON, MANAGER ]
}

export const forgotPasswordRoute = {
  name: 'FORGOT_PASSWORD',
  path: '/forgotPassword',
  url: '/forgotPassword'
}

export const resetPasswordRoute = {
  name: 'RESET_PASSWORD',
  path: '/resetPassword/:token',
  url: '/resetPassword'
}

export const usersRoute = {
  name: 'USERS',
  path: '/users',
  url: '/users',
  roles: [ ADMIN ]
}

export const userCreateRoute = {
  name: 'USERS_CREATE',
  path: '/users/new',
  url: '/users/new',
  roles: [ ADMIN ]
}

export const userEditRoute = {
  name: 'USERS_EDIT',
  url: '/users/edit',
  path: '/users/:id/edit',
  roles: [ ADMIN ]
}

export const userPasswordEditRoute = {
  name: 'USER_PASSWORDS_EDIT',
  url: '/users/editPassword',
  path: '/users/:id/editPassword/:returnRoute',
  roles: [ ADMIN ]
}

export const staffRoute = {
  name: 'STAFF',
  url: '/staff',
  path: '/staff',
  roles: [ ADMIN ]
}

export const staffCreateRoute = {
  name: 'STAFF_CREATE',
  path: '/staff/new',
  url: '/staff/new',
  roles: [ ADMIN ]
}

export const staffEditRoute = {
  name: 'STAFF_EDIT',
  url: '/staff/edit',
  path: '/staff/:id/edit',
  roles: [ ADMIN ]
}

export const clientsRoute = {
  name: 'CLIENTS',
  path: '/clients',
  url: '/clients',
  roles: [ ADMIN, RECRUITER, SALES_PERSON, MANAGER ]
}

export const clientCreateRoute = {
  name: 'CLIENTS_CREATE',
  path: '/clients/new',
  url: '/clients/new',
  roles: [ ADMIN, SALES_PERSON, MANAGER ]
}

export const clientEditRoute = {
  name: 'CLIENTS_EDIT',
  path: '/clients/:id/edit',
  url: '/clients/edit',
  roles: [ ADMIN, RECRUITER, SALES_PERSON, MANAGER ]
}

export const assignmentsRoute = {
  name: 'ASSIGNMENTS',
  path: '/assignments',
  url: '/assignments',
  roles: [ ADMIN, SALES_PERSON, RECRUITER, MANAGER ]
}

export const assignmentCreateRoute = {
  name: 'ASSIGNMENTS_CREATE',
  path: '/assignments/new',
  url: '/assignments/new',
  roles: [ ADMIN, MANAGER ]
}

export const assignmentEditRoute = {
  name: 'ASSIGNMENTS_EDIT',
  path: '/assignments/:id/edit',
  url: '/assignments/edit',
  roles: [ ADMIN, MANAGER, RECRUITER, SALES_PERSON ]
}

export const consultantTimeSheetRoute = {
  name: 'TIMESHEET',
  path: '/timesheet',
  url: '/timesheet',
  roles: [ CONSULTANT ]
}

export const timeCardReportRoute = {
  name: 'TIME_CARD_REPORT',
  url: '/timeCardReport',
  path: '/timeCardReport',
  roles: [ ADMIN, RECRUITER, SALES_PERSON, MANAGER ]
}

export const myProfileRoute = {
  name: 'MY_PROFILE',
  path: '/myprofile',
  url: '/myprofile',
  roles: [ ADMIN, CONSULTANT, RECRUITER, SALES_PERSON, MANAGER ]
}

export const directPlacementsRoute = {
  name: 'DIRECT_PLACEMENTS',
  path: '/directPlacements',
  url: '/directPlacements',
  roles: [ ADMIN, SALES_PERSON, RECRUITER, MANAGER ]
}

export const directPlacementCreateRoute = {
  name: 'DIRECT_PLACEMENTS_CREATE',
  path: '/directPlacements/new',
  url: '/directPlacements/new',
  roles: [ ADMIN, SALES_PERSON, MANAGER ]
}

export const directPlacementEditRoute = {
  name: 'DIRECT_PLACEMENTS_EDIT',
  url: '/directPlacements/edit',
  path: '/directPlacements/:id/edit',
  roles: [ ADMIN, SALES_PERSON, RECRUITER, MANAGER ]
}

export const commissionReportRoute = {
  name: 'COMMISSION_REPORT',
  path: '/commissionReport',
  url: '/commissionReport',
  roles: [ ADMIN, MANAGER ]
}

export const commissionDetailsReportRoute = {
  name: 'COMMISSION_DETAIL_REPORT',
  path: '/commissionDetailReport',
  url: '/commissionDetailReport',
  roles: [ ADMIN, MANAGER, SALES_PERSON, RECRUITER ]
}

export const invoiceReportRoute = {
  name: 'INVOICE_REPORT',
  path: '/invoicingReport',
  url: '/invoicingReport',
  roles: [ ADMIN, MANAGER ]
}

export const payrollReportRoute = {
  name: 'PAYROLL_REPORT',
  path: '/payrollReport',
  url: '/payrollReport',
  roles: [ ADMIN ]
}

export const projectsGPReportRoute = {
  name: 'PROJECTS_GP_REPORT',
  path: '/projectsGPReport',
  url: '/projectsGPReport',
  roles: [ ADMIN ]
}

export const gpToCostReportRoute = {
  name: 'GP_TO_COST_REPORT',
  path: '/gpToCost',
  url: '/gpToCost',
  roles: [ ADMIN, MANAGER ]
}

export const dashboardRoute = {
  name: 'ADMIN_DASHBOARD_ROUTE',
  path: '/dashboard',
  url: '/dashboard',
  roles: [ ADMIN, MANAGER, RECRUITER, SALES_PERSON, CONSULTANT ]
}

export const dealsRoute = {
  name: 'DEALS',
  path: '/deals',
  url: '/deals',
  roles: [ ADMIN, MANAGER, SALES_PERSON, RECRUITER ]
}

export const dealWizardRoute = {
  name: 'DEAL_WIZARD',
  path: '/deals/wizard/:id?/:step?/edit',
  url: '/deals/wizard',
  roles: [ ADMIN, MANAGER, SALES_PERSON, RECRUITER ]
}

export const userAdminTodosRoute = {
  name: 'USERTODOS',
  path: '/userAdminTodos',
  url: '/userAdminTodos',
  roles: [ ADMIN, RECRUITER, SALES_PERSON, MANAGER ]
}

export const userAdminTodoEditRoute = {
  name: 'USERADMINTODOEDIT',
  path: '/userAdminTodos/:id?/edit',
  url: '/userAdminTodos/edit',
  roles: [ ADMIN, MANAGER, SALES_PERSON, RECRUITER ]
}

export const userTodoEditRoute = {
  name: 'USERTODOEDIT',
  path: '/userTodoDashBoard/:id?/edit',
  url: '/userTodoDashBoard/edit',
  roles: [ ADMIN, CONSULTANT, RECRUITER, SALES_PERSON, MANAGER ]
}

export const userTodoDashboardRoute = {
  name: 'USERTODODASHBOARD',
  path: '/userTodoDashBoard',
  url: '/userTodoDashBoard',
  roles: [ ADMIN, CONSULTANT, RECRUITER, SALES_PERSON, MANAGER ]
}

export const teamsRoute = {
  name: 'TEAMSROUTE',
  path: '/teams',
  url: '/teams',
  roles: [ ADMIN ]
}

export const settingsRoute = {
  name: 'SETTINGSROUTE',
  path: '/settings',
  url: '/settings',
  roles: [ ADMIN ]
}

export const placementGoalsRoute = {
  name: 'PLACEMENTGOALSROUTE',
  path: '/placementGoals',
  url: '/placementGoals',
  roles: [ ADMIN, MANAGER ]
}

export const directPlacementGoalsRoute = {
  name: 'DIRECTPLACEMENTGOALSROUTE',
  path: '/directPlacementGoals',
  url: '/directPlacementGoals',
  roles: [ ADMIN, MANAGER ]
}

export const revenueDataRoute = {
  name: 'REVENUEDATAROUTE',
  path: '/revenue',
  url: '/revenue',
  roles: [ ADMIN ]
}

export const clockLogsRoute = {
  name: 'CLOCKINCLOCKOUTLOGSROUTE',
  path: '/clockLogs',
  url: '/clockLogs',
  roles: [ CONSULTANT ]
}

export const clockLogsReportRoute = {
  name: 'CLOCKINCLOCKOUTLOGSREPORTROUTE',
  path: '/clockLogsReport',
  url: '/clockLogsReport',
  roles: [ ADMIN ]
}

export const timeManagementRoute = {
  name: 'TIMEMANAGEMENTROUTE',
  path: '/timeManagement',
  url: '/timeManagement',
  roles: [ ADMIN ]
}
